import React, { useRef, useCallback } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './homepage.css';

const defaultTestimonials = [
  {
    quote: `My experience at My Private Chemist was nothing short of amazing. From the moment I arrived, I was warmly welcomed by the attentive staff at the reception and enveloped in a serene, calming atmosphere of the office managed by a very professional and warm-welcoming Pharmacists.`,
    author: 'Shem Wadowski',
  },
  {
    quote: `Great experience. Professional and speedy. Got an appointment for the the next day and I was in and out of the building in 5 minutes including adding a vaccine that wasn't in my original booking.`,
    author: 'Ian Bright',
  },
  {
    quote: `My Private Chemist provides an excellent service for anyone wanting to obtain prescriptions for regular medicines, where going to the doctor may take time effort that is not practical. I can fully recommend the quick and friendly service.`,
    author: 'Robin Myerscough-Walker',
  },
  {
    quote: `I had a medical issue while traveling and was recommended to go to this clinic. My experience was amazing! I got seen right away and all the staff were lovely – Sana was amazing. Thank you!!`,
    author: 'Rose Cranmer',
  },
];

const QUOTE_IMG = '/assets/images/testimonial-quote.png';

const TestimonialsSection = ({ testimonials = defaultTestimonials }) => {
  const trackRef = useRef(null);

  const equalizeHeights = useCallback(() => {
    if (!trackRef.current) return;
    const wraps = trackRef.current.querySelectorAll('.hp-testimonials__card-wrap');
    wraps.forEach(w => { w.style.height = ''; });
    const max = Math.max(...Array.from(wraps).map(w => w.offsetHeight));
    if (max > 0) wraps.forEach(w => { w.style.height = max + 'px'; });
  }, []);

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    onInit: equalizeHeights,
    onReInit: equalizeHeights,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="hp-testimonials">
      <div className="hp-testimonials__container">
        <h2 className="hp-testimonials__heading">
          What people say about My Private Chemist
        </h2>
        <div className="hp-testimonials__track" ref={trackRef}>
          <Slider {...settings}>
            {testimonials.map((t) => (
              <div key={t.author}>
                <div className="hp-testimonials__card-wrap">
                  <img
                    src={QUOTE_IMG}
                    alt=""
                    className="hp-testimonials__quote-img"
                    aria-hidden="true"
                  />
                  <div className="hp-testimonials__card">
                    <p className="hp-testimonials__card-text">{t.quote}</p>
                  </div>
                  <p className="hp-testimonials__card-name">{t.author}</p>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
